import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Redirect /preturi → homepage + scroll la secțiunea prețuri
 */
const RedirectPreturi = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true });
    setTimeout(() => {
      const element = document.getElementById('preturi');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }, [navigate]);

  return null;
};

export default RedirectPreturi;
